import { render, staticRenderFns } from "./BestTeamCard.vue?vue&type=template&id=25fc208a"
import script from "./BestTeamCard.vue?vue&type=script&lang=js"
export * from "./BestTeamCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports